export const USER_LOADED = "USER_LOADED";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT = "LOGOUT";
export const GET_BRANCH = "GET_BRANCH";
export const GET_EXECUTIVE = "GET_EXECUTIVE";
